import getAvailablePoliciesListState from '../selectors/getAvailablePoliciesListState';
import PolicyFetchRequestStatus from '../store/schema/PolicyFetchRequestStatus';

/**
 * Helper to check if current state is dirty or not
 */
export default function isRetentionPolicyStateDirty(): boolean {
    const availablePolicies = getAvailablePoliciesListState();
    return (
        availablePolicies.fetchRequestStatus === PolicyFetchRequestStatus.Complete &&
        [...availablePolicies.retentionPolicies.values()].some(element => element.isChecked)
    );
}
